module.exports = __webpack_public_path__ + "public/img/mn-open-top-black.8bfe892a.png";